module.exports = __webpack_public_path__ + "assets/images/img_support_ccon_v2.png";